export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/fitness_lessons.8ecd285.svg";